import React, { useEffect, useMemo, useRef, useState } from 'react'
import './Layout4B.css';


const Layout4B = ({ data }) => {

    const { canvas, video, brand, titles = [], products = [], subTitle } = data;

    const videoRef = useRef(null);
    const [mode, setMode] = useState("intro");
    const [startContentAnimation, setStartContentAnimation] = useState(false);

    useEffect(() => {

        const timer = setTimeout(() => {

            const videoEl = videoRef.current;
            if (!videoEl) return;

            const first = videoEl.getBoundingClientRect();

            setMode("normal");

            requestAnimationFrame(() => {

                const last = videoEl.getBoundingClientRect();

                const scaleX = first.width / last.width;
                const scaleY = first.height / last.height;

                const translateX = first.right - last.right;
                const translateY = first.bottom - last.bottom;

                videoEl.animate(
                    [
                        {
                            transformOrigin: "bottom right",
                            transform: `translate(${translateX}px, ${translateY}px) scale(${scaleX}, ${scaleY})`
                        },
                        {
                            transformOrigin: "bottom right",
                            transform: "translate(0px,0px) scale(1,1)"
                        }
                    ],
                    {
                        duration: 1200,
                        easing: "cubic-bezier(0.16, 1, 0.3, 1)",
                        fill: "both"
                    }
                );
                setStartContentAnimation(true);
            });
        }, 3000);

        return () => clearTimeout(timer);

    }, []);

    // --------- Filter Data ----------- //

    const filteredTitles = useMemo(
        () => (titles || []).filter(t => t && t.trim() !== ""),
        [titles]
    );

    const filteredProducts = useMemo(
        () => (products || []).filter(p => p && p.trim() !== ""),
        [products]
    );

    useEffect(() => {
        setCurrentIndex(0);
    }, [filteredTitles.length]);

    useEffect(() => {
        setCurrentImgIndex(0);
    }, [filteredProducts.length]);

    // --------- Animation States ----------- //

    const [currentIndex, setCurrentIndex] = useState(0);
    const [currentImgIndex, setCurrentImgIndex] = useState(0);
    const [animate, setAnimate] = useState(true);

    useEffect(() => {
        if (!startContentAnimation) return;

        const interval = setInterval(() => {

            // Title exit animation
            setAnimate(false);

            setTimeout(() => {

                setCurrentIndex((prev) =>
                    prev === filteredTitles.length - 1 ? 0 : prev + 1
                );

                setCurrentImgIndex((prev) =>
                    prev === filteredProducts.length - 1 ? 0 : prev + 1
                );

                setAnimate(true);

            }, 300); // title exit animation time

        }, 4000);

        return () => clearInterval(interval);

    }, [startContentAnimation, filteredTitles.length, filteredProducts.length]);

    return (
        <div className={`layout4B-container ${mode}`}>

            {/* Left Section */}
            <div className="layout4B-left">
                <div ref={videoRef} className="layout4B-video-section">
                    {video?.url ? (
                        <video
                            src={video.url}
                            autoPlay
                            muted
                            loop
                            playsInline
                            className="layout4B-video"
                        />
                    ) : (
                        <div className="layout4B-video-placeholder">
                            <div className="layout4B-play">▶</div>
                            <div>Upload Video</div>
                        </div>
                    )}
                </div>

                {/* BOTTOM SECTION */}
                {mode !== "intro" && (
                    <div
                        className="layout4B-bottom"
                        style={{ backgroundColor: canvas?.bottomBackgroundColor }}
                    >
                        <h1
                            className={`layout4B-animated-title ${animate ? "opacity-100" : "opacity-0"}`}
                            style={{ color: canvas?.titleTextColor }}
                        >
                            {filteredTitles[currentIndex]}
                        </h1>

                        <div className="layout4B-bottom-cta" style={{ backgroundColor: canvas?.sideBackgroundColor, color: canvas?.subTitleTextColor }}>
                            {subTitle}
                        </div>
                    </div>
                )}
            </div>


            {/* Right section */}
            {mode !== "intro" && (
                <div className='layout4B-right' style={{ backgroundColor: canvas?.sideBackgroundColor }}>

                    {/* Brand */}
                    <div className="layout4B-brand">
                        {brand?.logoUrl && (
                            <img src={brand.logoUrl} alt="logo" className="layout4B-logo" />
                        )}
                    </div>

                    {/* QR */}
                    <div className="layout4B-qr-wrapper">
                        {brand?.qrCodeUrl ? (
                            <img src={brand.qrCodeUrl} alt="QR" className="layout4B-qr" />
                        ) : (
                            <div className="layout4B-qr-placeholder">QR Code</div>
                        )}
                    </div>

                    {/* Products */}
                    <div className="layout4B-products">
                        {filteredProducts.length > 0 && (
                            <img
                                key={`product-${currentImgIndex}`}
                                src={filteredProducts[currentImgIndex]}
                                alt={`product-${currentImgIndex}`}
                                className="layout4B-product-img"
                            />
                        )}
                    </div>
                </div>
            )}
        </div>
    )
}

export default Layout4B